import getTranslatedTexts from '../text-resolvers/utils/getTranslatedTexts';
import { FAST_TRACK, LOUNGE, LOUNGE_PER_SEGMENT } from '../../products';
const AVAILABILITY_PRODUCT_NAME = {
  [FAST_TRACK.id]: FAST_TRACK.name,
  [LOUNGE.id]: LOUNGE.name,
  [LOUNGE_PER_SEGMENT.id]: LOUNGE_PER_SEGMENT.name
};
export const productTexts = {
  [FAST_TRACK.name]: {
    readMoreContent: 'fastTrackReadMoreModalContent',
    abstractContent: 'fastTrackAbstract',
    title: 'fastTrackTitle',
    upSell: 'fastTrackUpSellText',
    fasttrackAvailabilityCardAvailabilityTitle: 'fasttrackAvailabilityCardAvailabilityTitle',
    fasttrackAvailabilityCardDeparting: 'fasttrackAvailabilityCardDeparting',
    fasttrackAvailabilityCardReturn: 'fasttrackAvailabilityCardReturn',
    fasttrackAvailabilityCardAvailableStatus: 'fasttrackAvailabilityCardAvailableStatus',
    fasttrackAvailabilityCardUnavailableStatus: 'fasttrackAvailabilityCardUnavailableStatus',
    fasttrackAvailabilityCardAddedStatus: 'fasttrackAvailabilityCardAddedStatus',
    fasttrackAvailabilityCardAddedTitle: 'fasttrackAvailabilityCardAddedTitle',
    fasttrackAvailabilityCardStatusTooltip: 'fasttrackAvailabilityCardStatusTooltip',
    fasttrackCartPurchasedMessage: 'fasttrackCartPurchasedMessage'
  },
  [LOUNGE.name]: {
    additionalInformation: 'loungeAdditionalInformation',
    abstractContent: 'loungeAbstract',
    readMoreContent: 'loungeReadMoreModalContent',
    title: 'loungeTitle',
    upSell: 'loungeUpSellText',
    loungeAvailabilityCardAvailabilityTitle: 'loungeAvailabilityCardAvailabilityTitle',
    loungeAvailabilityCardDeparting: 'loungeAvailabilityCardDeparting',
    loungeAvailabilityCardReturn: 'loungeAvailabilityCardReturn',
    loungeAvailabilityCardAvailableStatus: 'loungeAvailabilityCardAvailableStatus',
    loungeAvailabilityCardUnavailableStatus: 'loungeAvailabilityCardUnavailableStatus',
    loungeAvailabilityCardAddedStatus: 'loungeAvailabilityCardAddedStatus',
    loungeAvailabilityCardAddedTitle: 'loungeAvailabilityCardAddedTitle',
    loungeAvailabilityCardStatusTooltip: 'loungeAvailabilityCardStatusTooltip',
    loungeAvailabilityCardSeeAll: 'loungeAvailabilityCardSeeAll',
    loungeDrawerOpeningFrom: 'loungeDrawerOpeningFrom',
    loungeDrawerOpeningTo: 'loungeDrawerOpeningTo',
    loungeDrawerOpeningTitle: 'loungeDrawerOpeningTitle',
    loungeDrawerAmenities: 'loungeDrawerAmenities',
    loungeDrawerLocation: 'loungeDrawerLocation',
    loungeDrawerCondition: 'loungeDrawerCondition',
    loungeDrawerTerminal: 'loungeDrawerTerminal',
    loungeCartPurchasedMessage: 'loungeCartPurchasedMessage',
    viReadMoreText: 'loungeViReadMoreText',
    viPromotionalPill: 'loungeViPromotionalPill'
  },
  [LOUNGE_PER_SEGMENT.name]: {
    abstractContent: 'loungePerSegmentAbstract',
    additionalInformation: 'loungePerSegmentAdditionalInformation',
    readMoreContent: 'loungePerSegmentReadMoreModalContent',
    title: 'loungePerSegmentTitle',
    upSell: 'loungePerSegmentUpSellText',
    loungePerSegmentAvailabilityCardAvailabilityTitle: 'loungePerSegmentAvailabilityCardAvailabilityTitle',
    loungePerSegmentAvailabilityCardDeparting: 'loungePerSegmentAvailabilityCardDeparting',
    loungePerSegmentAvailabilityCardReturn: 'loungePerSegmentAvailabilityCardReturn',
    loungePerSegmentAvailabilityCardAvailableStatus: 'loungePerSegmentAvailabilityCardAvailableStatus',
    loungePerSegmentAvailabilityCardUnavailableStatus: 'loungePerSegmentAvailabilityCardUnavailableStatus',
    loungePerSegmentAvailabilityCardAddedStatus: 'loungePerSegmentAvailabilityCardAddedStatus',
    loungePerSegmentAvailabilityCardAddedTitle: 'loungePerSegmentAvailabilityCardAddedTitle',
    loungePerSegmentAvailabilityCardStatusTooltip: 'loungePerSegmentAvailabilityCardStatusTooltip',
    loungePerSegmentAvailabilityCardSeeAll: 'loungePerSegmentAvailabilityCardSeeAll',
    loungePerSegmentCartPurchasedMessage: 'loungePerSegmentCartPurchasedMessage',
    loungePerSegmentDialogOpeningTitle: 'loungePerSegmentDialogOpeningTitle',
    loungePerSegmentDialogAmenities: 'loungePerSegmentDialogAmenities',
    loungePerSegmentDialogLocation: 'loungePerSegmentDialogLocation',
    loungePerSegmentDialogCondition: 'loungePerSegmentDialogCondition',
    loungePerSegmentCtaSelectPass: 'loungePerSegmentCtaSelectPass',
    loungePerSegmentCtaEditPass: 'loungePerSegmentCtaEditPass',
    loungePerSegmentCtaZeroPasses: 'loungePerSegmentCtaZeroPasses',
    loungePerSegmentDrawerTitle: 'loungePerSegmentDrawerTitle',
    loungePerSegmentDrawerCardTitle: 'loungePerSegmentDrawerCardTitle',
    loungePerSegmentDrawerTotalPrice: 'loungePerSegmentDrawerTotalPrice',
    loungePerSegmentDrawerSave: 'loungePerSegmentDrawerSave',
    loungePerSegmentValidationTitle: 'loungePerSegmentValidationTitle',
    loungePerSegmentValidationBody: 'loungePerSegmentValidationBody',
    loungePerSegmentValidationContinueWithout: 'loungePerSegmentValidationContinueWithout',
    loungePerSegmentValidationKeepEditing: 'loungePerSegmentValidationKeepEditing',
    priceLabelFrom: 'Products.Price.Label.From',
    priceLabelTotal: 'Products.Price.Label.Total'
  }
};
export const getAvailabilityProductName = productTypeId => AVAILABILITY_PRODUCT_NAME[Number(productTypeId)];
export const getProductTranslationsByProductId = (productId, t) => {
  const availabilityProductName = getAvailabilityProductName(productId);
  if (!availabilityProductName) {
    return {};
  }
  return getTranslatedTexts(productTexts[availabilityProductName], t);
};
//# sourceMappingURL=getProductTranslations.js.map